/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Mon Mar 13 2023
 **/

import { makeAPI } from "@/frameworks/core/API";
import UserService from "./api";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function withUser(events: API.Events, options: API.Options = { initialStart: false }) {
	const inquiryUserDetail = makeAPI<WebServices.User.InquiryUserDetail.Response>(
		UserService.user.inquiryUserDetail("inquiryUserDetail", events)
	);

	return {
		entrySpace: {
			inquiry: makeAPI<WebServices.User.EntrySpace.Inquiry.Response>(
				UserService.user.entrySpace.inquiry("entrySpace:inquiry", events)
			),
			update: makeAPI<WebServices.User.EntrySpace.Update.Response>(
				UserService.user.entrySpace.update("entrySpace:update", events)
			)
		},
		inquiryUsers: makeAPI<WebServices.User.InquiryUsers.Response>(
			UserService.user.inquiryUsers("inquiryUsers", events)
		),
		inquiryUserDetail,
		inquiry: inquiryUserDetail, // 하위 환성을 위해 사용
		me: {
			inquiry: makeAPI<WebServices.User.Me.Inquiry.Response>(UserService.user.me.inquiry("me:inquiry", events)),
			update: makeAPI<WebServices.User.Me.Update.Response>(UserService.user.me.update("me:update", events))
		},
		participatedSpace: makeAPI<WebServices.User.GetParticipatedSpace.Response>(
			UserService.user.participatedSpace("participatedSpace", events)
		),
		invitesList: makeAPI<WebServices.User.InvitesList.Response>(
			UserService.user.invitesList("invitesList", events)
		),
		avatar: {
			current: makeAPI<WebServices.User.Avatar.Current.Response>(
				UserService.user.avatar.current("avatar:current", events)
			),
			update: makeAPI<WebServices.User.Avatar.Update.Response>(
				UserService.user.avatar.update("avatar:update", events)
			),
			list: makeAPI<WebServices.User.Avatar.Get.Response>(UserService.user.avatar.list("avatar:list", events)),
			save: makeAPI<WebServices.User.Avatar.Save.Response>(UserService.user.avatar.save("avatar:save", events)),
			delete: makeAPI<WebServices.User.Avatar.Delete.Response>(
				UserService.user.avatar.delete("avatar:delete", events)
			),
			apply: makeAPI<WebServices.User.Avatar.Apply.Response>(
				UserService.user.avatar.apply("avatar:apply", events)
			)
		},
		connect: {
			inquiry: makeAPI<WebServices.User.GetConnectedUser.Response>(
				UserService.user.connect.inquiry("connect:inquiry", events)
			),
			update: makeAPI<WebServices.User.Connect.Response>(
				UserService.user.connect.update("connect:update", events)
			),
			delete: makeAPI<WebServices.User.DisconnectUser.Response>(
				UserService.user.connect.delete("connect:delete", events)
			)
		},
		marketingAgreement: makeAPI<WebServices.User.UpdateMarketingAgreement.Response>(
			UserService.user.updateMarketingAgreement("update:marketing", events)
		),
		checkBeforeFollow: makeAPI<WebServices.User.CheckBeforeFollow.Response>(
			UserService.user.checkBeforeFollow("checkBeforeFollow", events)
		),
		checkBeforeSummon: makeAPI<WebServices.User.CheckBeforeFollowMe.Response>(
			UserService.user.checkBeforeSummon("checkBeforeSummon", events)
		),
		withdraw: makeAPI<WebServices.User.WithdrawUser.Response>(UserService.user.withdrawUser("withdraw", events)),
		notificationLogs: {
			inquiry: makeAPI<WebServices.User.Notification.Inquiry.Response>(
				UserService.user.notificationLogs.inquiry("notificationLogs:inquiry", events)
			),
			read: makeAPI<WebServices.User.Notification.Read.Response>(
				UserService.user.notificationLogs.read("notificationLogs:read", events)
			),
			readAll: makeAPI<WebServices.User.Notification.ReadAll.Response>(
				UserService.user.notificationLogs.readAll("notificationLogs:readAll", events)
			),
			readByKey: makeAPI<WebServices.User.Notification.ReadByKey.Response>(
				UserService.user.notificationLogs.readByKey("notificationLogs:readByKey", events)
			)
		}
	};
}
